import {observable} from 'mobx';

class NavigationClass {
    @observable location = '';
    history = '';

    setLocation(location) {
        this.location = location;
    }

    setHistoryObject(history) {
        this.history = history;
    }
}

const Navigation = new NavigationClass();

export default Navigation;